var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "請求",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "div",
            { style: "width: " + _vm.maxWidth + "; overflow: scroll" },
            [
              _c(
                "div",
                { staticStyle: { width: "1320px" } },
                [
                  _c("b-table-filter", {
                    attrs: {
                      maxHeight: _vm.maxHeight,
                      filter_list: _vm.filter_list,
                      filter_val: _vm.filter_val,
                      data_list_field: _vm.data_list_field,
                      data_list: _vm.data_list,
                      filter_enable: true,
                    },
                    on: {
                      on_detail: _vm.toNouhinDetail,
                      on_delete: _vm.delNouhin,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("SeikyuDetail", {
        ref: "child_seikyu_detail",
        attrs: { modal_id: "seikyu2seikyu_detail" },
        on: { close_modal: _vm.closeDetailModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }